import React, { Fragment } from 'react';
import { useResponsive } from '@fuxi/eevee-hooks';
import { openURL } from 'common/utils';

import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { LoginProtocolList } from 'common/constants';

import { Checkbox, ConfigProvider } from '@fuxi/eevee-ui';

import cx from './index.module.css';

interface Props {
  value?: boolean;
  onChange?: (e: CheckboxChangeEvent) => void;
  readonly?: boolean;
}

const FormProtocol: React.FC<Props> = (props) => {
  const responsive = useResponsive();
  return (
    <ConfigProvider
      theme={{
        components: {
          Checkbox: {
            colorBgContainer: 'unset',
            // colorBorder: 'rgba(255, 255, 255, 0.5)',
          },
        },
      }}>
      <div className={cx('protocol-wrap')}>
        {!props.readonly && (
          <div className={cx('checkbox', responsive.xl && 'checkbox-large')}>
            <Checkbox {...props}></Checkbox>
          </div>
        )}
        <div className={cx('protocol', props.readonly && 'protocol-readonly', responsive.xl && 'protocol-large')}>
          我已阅读并同意
          {LoginProtocolList.map((item, index) => {
            return (
              <Fragment key={index}>
                <a onClick={() => openURL(item.url)}>{item.txt}</a>
                {index !== LoginProtocolList.length - 2 && index !== LoginProtocolList.length - 1 && '、'}
                {index === LoginProtocolList.length - 2 && '和'}
              </Fragment>
            );
          })}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default FormProtocol;
